import { Injectable } from '@angular/core';

export interface CustomWindow extends Window {
    AuthenticationContext: (this: CustomWindow) => void;
}

@Injectable()
export class WindowReferenceService {
    // noinspection JSMethodCanBeStatic
    get window(): CustomWindow {
        return window as CustomWindow;
    }
}
